import React, { useState, useEffect } from 'react';
import ListPage, { ui } from '../../components/ListPage';
import AutoDocumentModal from './AutoDocumentModal';
import { useFormButtons } from '../../utils/vbPerms';

const toFarsi = n => String(n).replace(/[0-9]/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
const toEng   = s => String(s).replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d).toString());

const EMPTY_FORM = {code:'', remark:'', description:'', transferal:false};

async function apiFetch(path, opts={}) {
  const doFetch = () => fetch(`/api/accounting${path}`, {
    headers:{'Content-Type':'application/json',
              Authorization:`Bearer ${localStorage.getItem('access')}`}, ...opts,
  });
  let res = await doFetch();
  if (res.status === 401) {
    const rr = await fetch('/api/auth/token/refresh/', {
      method:'POST', headers:{'Content-Type':'application/json'},
      body:JSON.stringify({refresh:localStorage.getItem('refresh')}),
    });
    if (rr.ok) { const d=await rr.json(); localStorage.setItem('access',d.access); res=await doFetch(); }
  }
  return res.json();
}

/* فیلدهای فرم — بیرون از بدنه تا هنگام تایپ دوباره ساخته نشوند */
const FL = ({label, children}) => (
  <div style={{display:'flex',flexDirection:'column',gap:'4px',marginBottom:'12px'}}>
    <label style={{fontSize:'12px',fontWeight:'600',color:'#555'}}>{label}</label>
    {children}
  </div>
);
const FI = ({name,value,onChange,placeholder}) => (
  <input name={name} value={value} onChange={onChange} placeholder={placeholder||''}
    style={{...ui.input, direction:'rtl', textAlign:'right'}}/>
);

export default function AccountingPattern({ user, onBack }) {
  // دکمه‌های فرم FRMPATTERN — دیدن دکمه = داشتن مجوز
  const vbf = useFormButtons('FRMPATTERN', ["BTNNEW","BTNEDIT","BTNDELETE","BTNCREATEDOCUMENTFROMPATTERN","BTNOK"]);
  // دکمه‌های فرم FRMPATTERNDETAIL — دیدن دکمه = داشتن مجوز
  const vbf_patterndetail = useFormButtons('FRMPATTERNDETAIL', ["BTNNEW","BTNDELETEALL","BTNDELETE"]);
  const curYear = new Date().toLocaleDateString('fa-IR').split('/')[0];
  const [year,     setYear]     = useState(curYear);
  const [search,   setSearch]   = useState('');
  const [data,     setData]     = useState([]);
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState('');
  const [selected, setSelected] = useState(null);
  const [popup,    setPopup]    = useState(null);
  const [modal,    setModal]    = useState(null);
  const [form,     setForm]     = useState(EMPTY_FORM);
  const [saving,   setSaving]   = useState(false);
  const [formErr,  setFormErr]  = useState('');
  const [toast,    setToast]    = useState('');
  const [showAutoDoc, setShowAutoDoc] = useState(false);
  const [artForm,  setArtForm]  = useState({sub_code:'', sub_name:'', all_taf:false, is_sum_article:false});
  const [artLookup,setArtLookup]= useState([]);
  const [artErr,   setArtErr]   = useState('');
  const [artSaving,setArtSaving]= useState(false);
  const [artToDel, setArtToDel] = useState(null);   // آرتیکلی که در انتظار تأیید حذف است
  const [confirmDelAll, setConfirmDelAll] = useState(false); // تأیید حذف همه آرتیکل‌ها

  const showToast = msg => { setToast(msg); setTimeout(()=>setToast(''),3000); };

  const fetchList = async (y, q) => {
    setLoading(true); setError('');
    const s = q !== undefined ? q : search;
    try {
      const token = localStorage.getItem('access');
      const res = await fetch(
        `/api/accounting/patterns/?search=${encodeURIComponent(s)}`,
        {headers:{Authorization:`Bearer ${token}`}});
      const json = await res.json();
      if (json.ok) setData(json.data || []);
      else setError(json.msg);
    } catch { setError('خطا در اتصال'); }
    finally { setLoading(false); }
  };

  useEffect(() => {
    (async () => {
      setLoading(true); setError('');
      try {
        const token = localStorage.getItem('access');
        const res = await fetch('/api/accounting/patterns/',
          {headers:{Authorization:`Bearer ${token}`}});
        const json = await res.json();
        if (json.ok) setData(json.data || []);
        else setError(json.msg);
      } catch { setError('خطا در اتصال'); }
      finally { setLoading(false); }
    })();
  }, []);

  const handleYearChange = e => {
    const v = toEng(e.target.value.replace(/[^0-9۰-۹]/g,'')).slice(0,4);
    setYear(v); if (v.length===4) fetchList(v);
  };

  const openPopup = async (pattern) => {
    setSelected(pattern);
    setPopup({pattern, details:[], loading:true});
    try {
      const j = await apiFetch(`/patterns/${pattern.id}/detail/?year=${year}`);
      setPopup({pattern, details: j.ok ? (j.data||[]) : [], loading:false, error:j.msg});
    } catch {
      setPopup(p=>({...p, loading:false, error:'خطا در اتصال'}));
    }
  };

  /* افزودن/ویرایش/حذف الگو */
  const openNew = () => { if (!vbf.can('BTNNEW')) return;
    setForm(EMPTY_FORM); setFormErr(''); setModal('new');
  };
  const openEdit = () => { if (!vbf.can('BTNEDIT')) return;
    if (!selected) return;
    setForm({
      code:        selected.code || '',
      remark:      selected.remark || '',
      description: selected.description || '',
      transferal:  !!selected.transferal,
    });
    setFormErr(''); setModal('edit');
  };
  const hf = e => {
    const {name,value,type,checked} = e.target;
    setForm(f=>({...f,[name]:type==='checkbox'?checked:value}));
  };
  const save = async () => {
    if (!form.code.trim()) { setFormErr('برای کد مقدار مشخص نشده است');   return; }
    if (!form.remark.trim()){ setFormErr('برای شرح مقدار مشخص نشده است'); return; }
    setSaving(true); setFormErr('');
    const payload = {code:form.code.trim(), remark:form.remark.trim(),
      description:form.description.trim(), transferal:form.transferal};
    const j = modal==='new'
      ? await apiFetch('/patterns/create/', {method:'POST', body:JSON.stringify(payload)})
      : await apiFetch(`/patterns/${selected.id}/update/`, {method:'PUT', body:JSON.stringify(payload)});
    setSaving(false);
    if (j.ok) { setModal(null); setSelected(null); setPopup(null); showToast(j.msg); fetchList(year); }
    else setFormErr(j.msg);
  };
  const doDelete = async () => {
    setSaving(true);
    const j = await apiFetch(`/patterns/${selected.id}/delete/`, {method:'DELETE'});
    setSaving(false);
    if (j.ok) { setModal(null); setSelected(null); setPopup(null); showToast('الگو حذف شد'); fetchList(year); }
    else { setFormErr(j.msg); setModal('del_blocked'); }
  };

  /* ریز الگو — جستجوی حساب معین */
  const lookupSubCoding = async (q) => {
    setArtForm(f=>({...f, sub_name:q}));
    if (!q.trim()) { setArtLookup([]); return; }
    const j = await apiFetch(`/sub-coding/lookup/?year=${year}&q=${encodeURIComponent(q)}`);
    setArtLookup(j.ok ? (j.data||[]) : []);
  };
  const pickSubCoding = (item) => {
    setArtForm(f=>({...f, sub_code:item.code, sub_name:`${item.code} - ${item.name}`}));
    setArtLookup([]);
  };
  const addArticle = async () => { if (!vbf_patterndetail.can('BTNNEW')) return;
    if (!artForm.sub_code) { setArtErr('حساب معین انتخاب نشده است'); return; }
    setArtSaving(true); setArtErr('');
    const j = await apiFetch(`/patterns/${popup.pattern.id}/detail/create/`, {
      method:'POST', body: JSON.stringify({
        sub_coding_code: artForm.sub_code,
        all_taf: artForm.all_taf, is_sum_article: artForm.is_sum_article,
      })});
    setArtSaving(false);
    if (j.ok) {
      setArtForm({sub_code:'', sub_name:'', all_taf:false, is_sum_article:false});
      showToast(j.msg); openPopup(popup.pattern); fetchList(year);
    } else setArtErr(j.msg);
  };
  const deleteArticle = async (detailId) => {
    const j = await apiFetch(`/patterns/detail/${detailId}/delete/`, {method:'DELETE'});
    setArtToDel(null);
    if (j.ok) { showToast('آرتیکل حذف شد'); openPopup(popup.pattern); fetchList(year); }
  };
  const deleteAllArticles = async () => { if (!vbf_patterndetail.can('BTNDELETEALL')) return;
    const j = await apiFetch(`/patterns/${popup.pattern.id}/detail/delete-all/`, {method:'DELETE'});
    setConfirmDelAll(false);
    if (j.ok) { showToast(j.msg); openPopup(popup.pattern); fetchList(year); }
  };

  /* الگوهای پیشنهادی — همه الگوها پاک می‌شن */
  const applySuggested = async () => { if (!vbf.can('BTNNEW')) return;
    setSaving(true);
    const j = await apiFetch('/patterns/suggestion/', {method:'POST'});
    setSaving(false);
    if (j.ok) { setModal(null); setSelected(null); setPopup(null); showToast(j.msg); fetchList(year); }
    else showToast('خطا: '+j.msg);
  };

  const toolbar = (
    <>
      <div style={ui.toolBtns}>
        {vbf.can('BTNNEW') && <button onClick={openNew} style={ui.btnNew}>＋ جدید</button>}
        {vbf.can('BTNEDIT') && <button onClick={openEdit} disabled={!selected}
          style={{...ui.btnEdit,opacity:selected?1:0.4,cursor:selected?'pointer':'default'}}>✎ ویرایش</button>}
        {vbf.can('BTNDELETE') && <button onClick={()=>{if(!selected)return;setFormErr('');setModal('delete');}} disabled={!selected}
          style={{...ui.btnDel,opacity:selected?1:0.4,cursor:selected?'pointer':'default'}}>✕ حذف</button>}
        {vbf.can('BTNCREATEDOCUMENTFROMPATTERN') && <button onClick={()=>{if(!selected||!selected.article_count)return;setShowAutoDoc(true);}}
          disabled={!selected||!selected.article_count}
          title={!selected?'ابتدا یک الگو انتخاب کنید':(!selected.article_count?'این الگو آرتیکل ندارد':'')}
          style={{...ui.btnEdit,background:'linear-gradient(135deg,#8d6e00,#C8A84B)',
            opacity:(selected&&selected.article_count)?1:0.4,
            cursor:(selected&&selected.article_count)?'pointer':'default'}}>🧮 ایجاد سند</button>}
        {vbf.can('BTNNEW') && <button onClick={()=>setModal('suggest')} style={ui.btnItems}>⬇️ دریافت الگوهای پیشنهادی</button>}
      </div>
      <div style={{display:'flex',flexDirection:'column',gap:'3px'}}>
        <label style={ui.flabel}>سال مالی</label>
        <input value={toFarsi(year)} onChange={handleYearChange}
          style={ui.yearInput} maxLength={4} placeholder="۱۴۰۵"/>
      </div>
      <div style={{display:'flex',flexDirection:'column',gap:'3px'}}>
        <label style={ui.flabel}>جستجو</label>
        <input value={search}
          onChange={e=>setSearch(e.target.value)}
          onKeyDown={e=>e.key==='Enter'&&fetchList(year)}
          style={{...ui.searchInput,width:'220px',alignSelf:'auto'}} placeholder="شرح یا کد الگو..."/>
      </div>
      <button onClick={()=>fetchList(year)} style={{...ui.btnNew,background:'#1a2f50'}}>🔍 جستجو</button>
      {(data||[]).length>0 &&
        <div style={ui.countBadge}>{toFarsi(String((data||[]).length))} الگو</div>}
      {loading && <span style={{fontSize:'18px',alignSelf:'flex-end'}}>⏳</span>}
    </>
  );

  return (
    <>
      <ListPage user={user} onBack={onBack} title="الگوی ثبت اسناد" subtitle="تنظیم حساب — سامانه ارجان"
        toolbar={toolbar} error={!modal ? error : ''}>
        {!loading && (data||[]).length>0 ? (
          <table style={ui.table}>
            <thead style={{position:'sticky',top:0,zIndex:10}}>
              <tr>
                <th style={ui.th}>کد</th>
                <th style={{...ui.th,textAlign:'right',width:'250px'}}>شرح</th>
                <th style={{...ui.th,textAlign:'right'}}>توضیح</th>
                <th style={ui.th}>تعداد آرتیکل</th>
                <th style={ui.th}>متمم</th>
              </tr>
            </thead>
            <tbody>
              {(data||[]).map((r,i)=>{
                const sel = selected?.id===r.id;
                const bg  = sel?'#1a2f50':i%2===0?'#fff':'#fdf6e3';
                return (
                  <tr key={r.id}
                    style={{background:bg,cursor:'pointer',transition:'background .1s'}}
                    onClick={()=>{ setSelected(sel?null:r); if(!sel) openPopup(r); else setPopup(null); }}
                    onMouseEnter={e=>{if(!sel)e.currentTarget.style.background='#e8f0fe';}}
                    onMouseLeave={e=>{if(!sel)e.currentTarget.style.background=bg;}}>
                    <td style={{...ui.td,fontWeight:'700',color:sel?'#C8A84B':'#1a237e',fontFamily:'monospace'}}>{r.code}</td>
                    <td style={{...ui.td,textAlign:'right',fontWeight:'600',color:sel?'#fff':'#333'}}>{r.remark}</td>
                    <td style={{...ui.td,textAlign:'right',color:sel?'rgba(255,255,255,0.7)':'#555',fontSize:'11px'}}>{r.description}</td>
                    <td style={{...ui.td,fontWeight:'700',color:sel?'#a5d6a7':'#1b5e20'}}>{toFarsi(String(r.article_count))}</td>
                    <td style={{...ui.td,color:sel?'#fff':'#333'}}>{r.transferal?'✓':''}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        ) : (
          <div style={ui.empty}>
            {loading ? <><div style={{fontSize:'40px',marginBottom:'12px'}}>⏳</div><div>در حال بارگذاری...</div></>
              : <><div style={{fontSize:'48px',marginBottom:'12px'}}>📭</div><div>الگویی برای سال {toFarsi(year)} یافت نشد</div></>}
          </div>
        )}
      </ListPage>

      {/* پاپ‌آپ آرتیکل‌های الگو */}
      {popup && (
        <div style={ui.overlay} onClick={()=>{setPopup(null);}}>
          <div style={{...ui.modal,maxWidth:'900px'}} onClick={e=>e.stopPropagation()}>
            <div style={{...ui.mHeader,alignItems:'flex-start'}}>
              <div>
                <div style={ui.mTitle}>📋 الگو: {popup.pattern.remark}</div>
                <div style={s.modalSub}>
                  کد {popup.pattern.code} | {toFarsi(String(popup.pattern.article_count))} آرتیکل
                  {popup.pattern.description?` | ${popup.pattern.description}`:''}
                  {popup.pattern.transferal?' | متمم':''}
                </div>
              </div>
              <button onClick={()=>setPopup(null)} style={ui.closeBtn}>✕</button>
            </div>
            <div style={{...ui.mBody,overflowX:'auto',padding:'16px'}}>
              {/* فرم افزودن آرتیکل جدید */}
              <div style={{background:'#f8f9ff',border:'1.5px solid #e8eaf6',borderRadius:'9px',
                padding:'10px 12px',marginBottom:'12px',position:'relative'}}>
                {artErr && <div style={{...ui.errBox,marginBottom:'8px',padding:'6px 10px',fontSize:'11px'}}>⚠️ {artErr}</div>}
                <div style={{display:'flex',gap:'8px',flexWrap:'wrap',alignItems:'flex-end'}}>
                  <div style={{flex:'1 1 220px',position:'relative'}}>
                    <label style={{fontSize:'11px',fontWeight:'600',color:'#555'}}>حساب معین (کد یا نام)</label>
                    <input value={artForm.sub_name}
                      onChange={e=>lookupSubCoding(e.target.value)}
                      placeholder="مثلاً 41001 یا بخشی از نام حساب"
                      style={{width:'100%',boxSizing:'border-box',padding:'7px 10px',
                        border:'1.5px solid #e0e0e0',borderRadius:'7px',fontSize:'12px',
                        fontFamily:'inherit',direction:'rtl',textAlign:'right',outline:'none'}}/>
                    {artLookup.length>0 && (
                      <div style={{position:'absolute',top:'100%',right:0,left:0,zIndex:20,
                        background:'#fff',border:'1px solid #ddd',borderRadius:'7px',
                        maxHeight:'160px',overflowY:'auto',boxShadow:'0 6px 18px rgba(0,0,0,0.15)'}}>
                        {artLookup.map(it=>(
                          <div key={it.code} onClick={()=>pickSubCoding(it)}
                            style={{padding:'6px 10px',fontSize:'11.5px',cursor:'pointer',
                              borderBottom:'1px solid #f2f2f2'}}
                            onMouseEnter={e=>e.currentTarget.style.background='#eef2ff'}
                            onMouseLeave={e=>e.currentTarget.style.background='#fff'}>
                            <b style={{fontFamily:'monospace'}}>{it.code}</b> — {it.name}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  <label style={{display:'flex',alignItems:'center',gap:'5px',fontSize:'11px',
                    padding:'7px 9px',borderRadius:'7px',background:'#fff',border:'1.5px solid #e0e0e0',cursor:'pointer'}}>
                    <input type="checkbox" checked={artForm.is_sum_article}
                      onChange={e=>setArtForm(f=>({...f,is_sum_article:e.target.checked}))}/>
                    با توجه به تراز
                  </label>
                  <label style={{display:'flex',alignItems:'center',gap:'5px',fontSize:'11px',
                    padding:'7px 9px',borderRadius:'7px',background:'#fff',border:'1.5px solid #e0e0e0',cursor:'pointer'}}>
                    <input type="checkbox" checked={artForm.all_taf}
                      onChange={e=>setArtForm(f=>({...f,all_taf:e.target.checked}))}/>
                    فقط تفصیلی‌های سناما
                  </label>
                  {vbf_patterndetail.can('BTNNEW') && <button onClick={addArticle} disabled={artSaving} style={ui.btnNew}>
                    {artSaving?'⏳...':'＋ افزودن آرتیکل'}
                  </button>}
                </div>
              </div>

              {popup.loading ? (
                <div style={s.modalEmpty}>⏳ در حال بارگذاری...</div>
              ) : popup.error ? (
                <div style={s.modalEmpty}>⚠️ {popup.error}</div>
              ) : (popup.details||[]).length===0 ? (
                <div style={s.modalEmpty}>📭 آرتیکلی یافت نشد</div>
              ) : (
                <table style={{...ui.table,fontSize:'12px'}}>
                  <thead>
                    <tr>
                      <th style={s.mth}>ردیف</th>
                      <th style={s.mth}>کد کل</th>
                      <th style={{...s.mth,textAlign:'right',minWidth:'130px'}}>شرح حساب کل</th>
                      <th style={s.mth}>کد معین</th>
                      <th style={{...s.mth,textAlign:'right',minWidth:'130px'}}>شرح حساب معین</th>
                      <th style={s.mth}>نحوه محاسبه</th>
                      <th style={s.mth}>تفکیک تفصیلی</th>
                      <th style={s.mth}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {(popup.details||[]).map((d,i)=>(
                      <tr key={d.id} style={{background:i%2===0?'#fff':'#f8f9ff'}}>
                        <td style={{...s.mtd,fontWeight:'700',color:'#1a237e'}}>{toFarsi(String(d.sequence))}</td>
                        <td style={{...s.mtd,fontFamily:'monospace',fontWeight:'700'}}>{d.coding_code}</td>
                        <td style={{...s.mtd,textAlign:'right'}}>{d.coding_name}</td>
                        <td style={{...s.mtd,fontFamily:'monospace',fontWeight:'700',color:'#4a148c'}}>{d.sub_code}</td>
                        <td style={{...s.mtd,textAlign:'right'}}>{d.sub_name}</td>
                        <td style={{...s.mtd,color:'#555'}}>{d.calc_method}</td>
                        <td style={{...s.mtd,fontSize:'10px',color:'#777'}}>{d.all_taf_name}</td>
                        <td style={s.mtd}>
                          {vbf_patterndetail.can('BTNDELETE') && <button onClick={()=>setArtToDel(d)}
                            style={{background:'#ffebee',color:'#c62828',border:'1px solid #ffcdd2',
                              borderRadius:'5px',cursor:'pointer',fontSize:'11px',padding:'2px 8px'}}>
                            ✕
                          </button>}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
            <div style={{...ui.mFooter,justifyContent:'space-between',alignItems:'center'}}>
              {vbf_patterndetail.can('BTNDELETEALL') && <button onClick={()=>setConfirmDelAll(true)} disabled={!(popup.details||[]).length}
                style={{...ui.btnDel,opacity:(popup.details||[]).length?1:0.3,fontSize:'12px',padding:'6px 14px'}}>
                🗑️ حذف همه آرتیکل‌ها
              </button>}
              <span style={{color:'#888',fontSize:'12px'}}>برای بستن کلیک کنید یا خارج از کادر بزنید</span>
              <button onClick={()=>setPopup(null)} style={s.closeFooterBtn}>بستن</button>
            </div>
          </div>
        </div>
      )}

      {/* پاپ‌آپ جدید / ویرایش */}
      {(modal==='new'||modal==='edit') && (
        <div style={ui.overlay} onClick={()=>setModal(null)}>
          <div style={{...ui.modal,maxWidth:'480px'}} onClick={e=>e.stopPropagation()}>
            <div style={ui.mHeader}>
              <div style={ui.mTitle}>
                {modal==='new'?'＋ الگوی جدید':`✎ ویرایش: ${selected?.remark}`}
              </div>
              <button onClick={()=>setModal(null)} style={ui.closeBtn}>✕</button>
            </div>
            <div style={ui.mBody}>
              {formErr && <div style={ui.errBox}>⚠️ {formErr}</div>}
              <FL label="کد الگو *">
                <FI name="code" value={form.code} onChange={hf} placeholder="مثلاً 1-1"/>
              </FL>
              <FL label="شرح *">
                <FI name="remark" value={form.remark} onChange={hf} placeholder="شرح الگو"/>
              </FL>
              <FL label="توضیح">
                <FI name="description" value={form.description} onChange={hf} placeholder="توضیحات اضافی"/>
              </FL>
              <label style={{display:'flex',alignItems:'center',gap:'8px',cursor:'pointer',
                padding:'8px 12px',borderRadius:'8px',
                background:form.transferal?'#e8f5e9':'#f5f5f5',
                border:`1.5px solid ${form.transferal?'#2e7d32':'#e0e0e0'}`,
                fontSize:'13px',userSelect:'none'}}>
                <input type="checkbox" name="transferal" checked={form.transferal} onChange={hf}
                  style={{width:'15px',height:'15px'}}/>
                دوره متمم
              </label>
            </div>
            <div style={ui.mFooter}>
              <button onClick={()=>setModal(null)} style={ui.btnCancel}>انصراف</button>
              {vbf.can('BTNOK') && <button onClick={save} disabled={saving} style={ui.btnSave}>
                {saving?'⏳ ذخیره...':'💾 ذخیره'}
              </button>}
            </div>
          </div>
        </div>
      )}

      {/* پاپ‌آپ حذف */}
      {modal==='delete' && (
        <div style={ui.overlay} onClick={()=>setModal(null)}>
          <div style={{...ui.modal,maxWidth:'440px'}} onClick={e=>e.stopPropagation()}>
            <div style={{...ui.mHeader,background:'linear-gradient(135deg,#b71c1c,#c62828)'}}>
              <div style={ui.mTitle}>⚠️ تأیید حذف</div>
              <button onClick={()=>setModal(null)} style={ui.closeBtn}>✕</button>
            </div>
            <div style={{...ui.mBody,textAlign:'center',padding:'28px'}}>
              <div style={{fontSize:'36px',marginBottom:'12px'}}>🗑️</div>
              <div style={{background:'#fff3f3',border:'1px solid #ffcdd2',
                borderRadius:'8px',padding:'12px',fontWeight:'700',color:'#b71c1c'}}>
                {selected?.remark}
                <br/><span style={{fontSize:'12px',fontWeight:'400'}}>کد: {selected?.code}</span>
              </div>
              <div style={{fontSize:'12px',color:'#999',marginTop:'10px'}}>
                اگر این الگو آرتیکل داشته باشد حذف امکان‌پذیر نیست
              </div>
            </div>
            <div style={ui.mFooter}>
              <button onClick={()=>setModal(null)} style={ui.btnCancel}>خیر، انصراف</button>
              {vbf.can('BTNDELETE') && <button onClick={doDelete} disabled={saving} style={{...ui.btnSave,background:'#b71c1c'}}>
                {saving?'⏳...':'بله، حذف شود'}
              </button>}
            </div>
          </div>
        </div>
      )}

      {/* خطای حذف */}
      {modal==='del_blocked' && (
        <div style={ui.overlay} onClick={()=>{setModal(null);setFormErr('');}}>
          <div style={{...ui.modal,maxWidth:'420px'}} onClick={e=>e.stopPropagation()}>
            <div style={{...ui.mHeader,background:'linear-gradient(135deg,#e65100,#f57c00)'}}>
              <div style={ui.mTitle}>🚫 عدم امکان حذف</div>
              <button onClick={()=>{setModal(null);setFormErr('');}} style={ui.closeBtn}>✕</button>
            </div>
            <div style={{...ui.mBody,textAlign:'center',padding:'28px',
              fontSize:'14px',color:'#1a2f50',fontWeight:'700'}}>
              {formErr}
            </div>
            <div style={ui.mFooter}>
              <button onClick={()=>{setModal(null);setFormErr('');}} style={ui.btnSave}>باشه</button>
            </div>
          </div>
        </div>
      )}

      {/* تأیید دریافت الگوهای پیشنهادی */}
      {modal==='suggest' && (
        <div style={ui.overlay} onClick={()=>setModal(null)}>
          <div style={{...ui.modal,maxWidth:'460px'}} onClick={e=>e.stopPropagation()}>
            <div style={{...ui.mHeader,background:'linear-gradient(135deg,#4a148c,#6a1b9a)'}}>
              <div style={ui.mTitle}>⚠️ هشدار</div>
              <button onClick={()=>setModal(null)} style={ui.closeBtn}>✕</button>
            </div>
            <div style={{...ui.mBody,textAlign:'center',padding:'26px',fontSize:'13px',color:'#1a2f50'}}>
              با دریافت الگوی پیشنهادی، <b>همه الگوهای موجود حذف</b> خواهد شد.
              <br/><br/>آیا با دریافت الگوی پیشنهادی موافق هستید؟
            </div>
            <div style={ui.mFooter}>
              <button onClick={()=>setModal(null)} style={ui.btnCancel}>خیر</button>
              {vbf.can('BTNNEW') && <button onClick={applySuggested} disabled={saving}
                style={{...ui.btnSave,background:'linear-gradient(135deg,#4a148c,#6a1b9a)'}}>
                {saving?'⏳...':'بلی'}
              </button>}
            </div>
          </div>
        </div>
      )}

      {showAutoDoc && selected && (
        <AutoDocumentModal
          year={year}
          onClose={()=>setShowAutoDoc(false)}
          onCreated={()=>{setShowAutoDoc(false);fetchList(year);}}
        />
      )}

      {/* تأیید حذف یک آرتیکل */}
      {artToDel && (
        <div style={{...ui.overlay, zIndex:4000}} onClick={()=>setArtToDel(null)}>
          <div style={{...ui.modal,maxWidth:'440px'}} onClick={e=>e.stopPropagation()}>
            <div style={{...ui.mHeader,background:'linear-gradient(135deg,#b71c1c,#c62828)'}}>
              <div style={ui.mTitle}>⚠️ تأیید حذف آرتیکل</div>
              <button onClick={()=>setArtToDel(null)} style={ui.closeBtn}>✕</button>
            </div>
            <div style={{...ui.mBody,textAlign:'center',padding:'24px',fontSize:'13px',color:'#1a2f50'}}>
              آیا از حذف این آرتیکل مطمئن هستید؟
              <div style={{marginTop:'12px',background:'#fff3f3',border:'1px solid #ffcdd2',
                borderRadius:'8px',padding:'10px',fontWeight:'700',color:'#b71c1c',fontSize:'12px'}}>
                ردیف {toFarsi(String(artToDel.sequence))} — کد معین {artToDel.sub_code}
                <br/><span style={{fontWeight:'400'}}>{artToDel.sub_name}</span>
              </div>
            </div>
            <div style={ui.mFooter}>
              <button onClick={()=>setArtToDel(null)} style={ui.btnCancel}>خیر، انصراف</button>
              {vbf_patterndetail.can('BTNDELETE') && <button onClick={()=>deleteArticle(artToDel.id)} style={{...ui.btnDel,padding:'8px 20px'}}>
                بله، حذف شود
              </button>}
            </div>
          </div>
        </div>
      )}

      {/* تأیید حذف همه آرتیکل‌ها */}
      {confirmDelAll && (
        <div style={{...ui.overlay, zIndex:4000}} onClick={()=>setConfirmDelAll(false)}>
          <div style={{...ui.modal,maxWidth:'440px'}} onClick={e=>e.stopPropagation()}>
            <div style={{...ui.mHeader,background:'linear-gradient(135deg,#b71c1c,#c62828)'}}>
              <div style={ui.mTitle}>⚠️ هشدار</div>
              <button onClick={()=>setConfirmDelAll(false)} style={ui.closeBtn}>✕</button>
            </div>
            <div style={{...ui.mBody,textAlign:'center',padding:'26px',fontSize:'13px',color:'#1a2f50'}}>
              آیا از حذف کلیه اقلام مطمئن هستید؟
            </div>
            <div style={ui.mFooter}>
              <button onClick={()=>setConfirmDelAll(false)} style={ui.btnCancel}>خیر</button>
              {vbf_patterndetail.can('BTNDELETEALL') && <button onClick={deleteAllArticles} style={{...ui.btnDel,padding:'8px 20px'}}>
                بلی، همه حذف شوند
              </button>}
            </div>
          </div>
        </div>
      )}

      {toast && <div style={ui.toast}>{toast}</div>}
    </>
  );
}

/* استایل‌های اختصاصی جدول ریز الگو داخل پاپ‌آپ */
const s = {
  modalSub:  {fontSize:'11px',color:'rgba(255,255,255,0.65)',marginTop:'4px'},
  modalEmpty:{textAlign:'center',padding:'40px',color:'#999',fontSize:'14px'},
  mth:       {padding:'8px 10px',background:'#1a237e',color:'#fff',fontWeight:'700',
              textAlign:'center',whiteSpace:'nowrap',
              borderLeft:'1px solid rgba(255,255,255,0.1)',fontFamily:'inherit',fontSize:'11px',position:'sticky',top:0,zIndex:2},
  mtd:       {padding:'7px 10px',borderBottom:'1px solid #f0f0f0',
              textAlign:'center',color:'#333',whiteSpace:'nowrap',fontSize:'12px'},
  closeFooterBtn:{padding:'7px 20px',background:'#1a2f50',color:'#fff',border:'none',
              borderRadius:'8px',cursor:'pointer',fontFamily:'inherit',fontSize:'13px'},
};
